import { buildListSearch, parseListPage } from "./listQueryParams";

export const ADMIN_HOME_PATH = "/admin/home";

export type AdminHomeListQuery = {
  page: number;
  searchValue: string;
};

export const DEFAULT_ADMIN_HOME_LIST_QUERY: AdminHomeListQuery = {
  page: 0,
  searchValue: "",
};

export const parseAdminHomeListQuery = (
  search: string
): AdminHomeListQuery => {
  const params = new URLSearchParams(search);
  return {
    page: parseListPage(params.get("page")),
    searchValue: params.get("searchValue") ?? "",
  };
};

export const buildAdminHomeListSearch = (
  query: AdminHomeListQuery
): string => buildListSearch(query);
